import React, { useEffect, useState } from 'react';
import {
    Grid,
    Card,
    CardContent,
    Typography,
    Button,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';
import { fetchDealers, deleteDealer, updateDealer } from '../api/licenseService';
import CreateDealerDialog from './CreateDealerDialog';
import EditDealerDialog from './EditDealerDialog';

const DealerOverview = () => {
    const [dealers, setDealers] = useState([]);
    const [showCreateDialog, setShowCreateDialog] = useState(false);
    const [dealerToEdit, setDealerToEdit] = useState(null);
    const [dealerToDelete, setDealerToDelete] = useState(null);

    const loadDealers = async () => {
        const apiKey = localStorage.getItem('apiKey');
        const res = await fetchDealers(apiKey);
        setDealers(res || []);
    };

    useEffect(() => {
        loadDealers();
    }, []);

    const handleDelete = async () => {
        await deleteDealer(dealerToDelete.id);
        setDealerToDelete(null);
        loadDealers();
    };

    return (
        <Box>
            <Button
                variant="contained"
                sx={{ mb: 2 }}
                onClick={() => setShowCreateDialog(true)}
            >
                Händler hinzufügen
            </Button>

            <Grid container spacing={2}>
                {dealers.map((dealer) => (
                    <Grid item xs={12} md={6} key={dealer.id}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6">{dealer.name}</Typography>
                                <Typography variant="body2">Vorname: {dealer.firstName}</Typography>
                                <Typography variant="body2">Email: {dealer.email}</Typography>
                                <Typography variant="body2">Telefon: {dealer.phoneNumber}</Typography>
                                <Typography variant="body2">Adresse: {dealer.address}</Typography>
                                <Typography variant="body2">Lizenzen: {dealer.licenseCount}</Typography>
                                <Typography variant="body2">
                                    Master: {dealer.isMaster ? 'Ja' : 'Nein'}
                                </Typography>

                                <Box mt={2} display="flex" gap={1}>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={() => setDealerToEdit(dealer)}
                                    >
                                        Bearbeiten
                                    </Button>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        color="error"
                                        onClick={() => setDealerToDelete(dealer)}
                                    >
                                        Löschen
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {showCreateDialog && (
                <CreateDealerDialog
                    onClose={() => setShowCreateDialog(false)}
                    onCreated={loadDealers}
                />
            )}

            {dealerToEdit && (
                <EditDealerDialog
                    dealer={dealerToEdit}
                    onClose={() => setDealerToEdit(null)}
                    onSave={async (updated) => {
                        await updateDealer(updated);
                        setDealerToEdit(null);
                        loadDealers();
                    }}
                />
            )}

            {dealerToDelete && (
                <Dialog open onClose={() => setDealerToDelete(null)}>
                    <DialogTitle>Händler löschen</DialogTitle>
                    <DialogContent>
                        <Typography>
                            Möchten Sie den Händler <strong>{dealerToDelete.name}</strong>{' '}
                            wirklich löschen?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDealerToDelete(null)}>Abbrechen</Button>
                        <Button variant="contained" color="error" onClick={handleDelete}>
                            Löschen
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </Box>
    );
};

export default DealerOverview;
